import { localize } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { FollowersClauseLabel } from "@radarly/models/clause/label";
import { LabelNode } from "./index";

export const getFollowersLabelNode = (
  type: LabelNode,
  label: FollowersClauseLabel,
  locale: Locale
) => {
  if (type === "no-range") return followersLabelNoRange(locale);
  if (type === "from") return followersLabelFrom(label, locale);
  if (type === "to") return followersLabelTo(label, locale);
  return followersLabelDefault(label, locale);
};

const followersLabelNoRange = (locale: Locale) => {
  return tr(locale, "FACETS::AUTHORFOLLOWERS::TITLE");
};

const followersLabelFrom = (label: FollowersClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AUTHORFOLLOWERS::INTERVAL_FROM", {
    from: localize(locale, label.gt),
  });
};

const followersLabelTo = (label: FollowersClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AUTHORFOLLOWERS::INTERVAL_TO", {
    to: localize(locale, label.lt),
  });
};

const followersLabelDefault = (label: FollowersClauseLabel, locale: Locale) => {
  return tr(locale, "FACETS::AUTHORFOLLOWERS::INTERVAL_FROM_TO", {
    from: localize(locale, label.gt),
    to: localize(locale, label.lt),
  });
};
